// react-native-screens resolves to its CommonJS (native) build on web, where
// Screen/ScreenContainer render the native screen component (our codegen
// null-stub) with visibility:hidden / height:0 — so the active screen's content
// is in the DOM but invisible. screensEnabled()=false tells react-navigation to
// use its plain-View fallback instead of native Screens; the component exports
// are full-size Views as a safety net.
const React = require("react");
const { View } = require("react-native"); // → react-native-web

const mkView = (base) =>
  React.forwardRef((props, ref) => {
    const { children, style, ...rest } = props || {};
    return React.createElement(View, { ref, style: [base, style], ...rest }, children);
  });
const FullView = mkView({ flex: 1 });
const Null = () => null;

module.exports = {
  __esModule: true,
  default: FullView,
  enableScreens: () => {},
  enableFreeze: () => {},
  screensEnabled: () => false,
  shouldUseActivityState: false,
  isSearchBarAvailableForCurrentPlatform: false,
  isNewBackTitleImplementation: false,
  Screen: FullView,
  ScreenContainer: FullView,
  ScreenStack: FullView,
  NativeScreen: FullView,
  InnerScreen: FullView,
  ScreenContext: React.createContext(FullView),
  ScreenStackHeaderConfig: Null,
  ScreenStackHeaderSubview: Null,
  ScreenStackHeaderLeftView: Null,
  ScreenStackHeaderCenterView: Null,
  ScreenStackHeaderRightView: Null,
  ScreenStackHeaderBackButtonImage: Null,
  ScreenStackHeaderSearchBarView: Null,
  SearchBar: Null,
  FullWindowOverlay: ({ children }) => children || null,
};
